import { useState } from 'react';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../common/EditPage';
import { create } from './../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';


const ResellerCreate = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const handleSave = () => {
        create('/admin/resellers/resellers', {data: data}).then(response => {
            toast.success("Reseller created successfully", {});
            navigate('/resellers/resellers');
        }).catch(error => {
            toast.error("Error creating reseller: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/resellers/resellers');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    return <div>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick={true}
            pauseOnHover={true}
            draggable={true}
            progress="undefined"
        />
        <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Reseller" >
            <EditPagePanel>
                <EditPageTextField label="Name" id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                <EditPageTextField label="Email" id="ATREMAIL" onChange={ onChange } value={ data.ATREMAIL } />
                <EditPageCheckbox label="Active" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
            </EditPagePanel>
        </EditPage>
    </div>
}

export default ResellerCreate;